/*
  MT sticky ATC klavye bekçisi (spec/port-pdp.md §4.1, research/v3/mobil.md §3.3, Q26).
  Ekran klavyesi açıkken (visualViewport.height < innerHeight × 0,75) <html> ve her sticky-add-to-cart
  data-mt-kb alır; assets/mt-pdp.css çubuğu gizler. Görünürlüğün geri kalanı Horizon'da (sticky-add-to-cart.js).
*/
const vv = window.visualViewport;
const sync = () => {
  const kb = vv.height < window.innerHeight * 0.75;
  document.documentElement.toggleAttribute('data-mt-kb', kb);
  document.querySelectorAll('sticky-add-to-cart').forEach((el) => el.toggleAttribute('data-mt-kb', kb));
};
if (vv && !window.__mtStickyGuard) {
  window.__mtStickyGuard = true;
  vv.addEventListener('resize', sync);
  sync();
}
